var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
import useIosContext from "@nitra/nkmb-card-components/contexts/IosContextProvider";
import { getLocalizedString } from "@nitra/nkmb-card-components/utils";
import { useTranslation } from "react-i18next";
export var CardOverImageTitle = function (props) {
    var _a;
    var title = props.title, localizedTitle = props.localizedTitle, variant = props.variant;
    var isIos = useIosContext().isIos;
    var theme = useTheme();
    var i18n = useTranslation().i18n;
    var currentLang = i18n.language;
    return (_jsx(Typography, __assign({ variant: variant !== null && variant !== void 0 ? variant : "h5", component: "div", sx: __assign((_a = { color: "background.paper", zIndex: 1, textTransform: "uppercase" }, _a[theme.breakpoints.down("sm")] = !!variant && isIos && {
            '@media (-webkit-min-device-pixel-ratio: 2)': {
                fontWeight: 500, // Adjust font weight for iPhones
            },
        }, _a), props.sx) }, { children: !!localizedTitle ? getLocalizedString(localizedTitle, currentLang) : title })));
};
